import { render, staticRenderFns } from "./apiShop.vue?vue&type=template&id=f140a5f4&scoped=true&"
import script from "./apiShop.vue?vue&type=script&lang=js&"
export * from "./apiShop.vue?vue&type=script&lang=js&"
import style0 from "./apiShop.vue?vue&type=style&index=0&id=f140a5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f140a5f4",
  null
  
)

export default component.exports